/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, inject, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Document } from '@src/app/model/document';
import { DocumentService } from '@src/app/modules/crm/document.service';
import { DocumentPageNavRoute } from '@src/app/routes/app-router';
import { ChosenWidget, IWidget } from '@src/app/shared/dashboard/DashboardTypes';

@Component({
    selector: 'app-documents-widget',
    imports: [RouterLink],
    templateUrl: './documents-widget.component.html',
    styleUrls: ['../../../../shared/dashboard/hello-world-widget/widget.component.scss']
})
export class DocumentWidgetComponent  implements IWidget, OnInit {
  @Input() chosenWidget: ChosenWidget;

  title = $localize `Omc Documentation`;
  host: ElementRef<Element> = inject(ElementRef);
  options: { name: string; action: () => void; }[];
  docSvc = inject(DocumentService)
  maxItems = 10;
  routerLink = DocumentPageNavRoute.getListRouterLink();

  data: Document[] = [];  

  ngOnInit(): void {
    const parms = new HttpParams().set('_limitTo', this.maxItems).set('_sortDesc', 'updatedAt');
    this.docSvc.get<Document>(false, parms).subscribe( data => {
      this.data = data;
    })
  }

  getNavRoute(p: Document) {
    return [DocumentPageNavRoute.getIdUrl(p.id, p.teamId)];
  }
}
